import { ReportType } from "./reportsTypes";

export type TGeneralSeaAreasSliceState = {
    generalSeaAreasData: TGeneralSeaAreas[] | null;
    generalSeaAreasLoading: boolean;
    generalSeaAreasError: Error | null;
};

export type TActivityReportSliceState = {
    activityReportData: any | null;
    activityReportLoading: boolean;
    activityReportError: Error | null;
};

export type TStoppageEventsReportSliceState = {
    stoppageEventsData: any | null;
    stoppageEventsLoading: boolean;
    stoppageEventsError: Error | null;
};

export type TPortCallsReportSliceState = {
    portCallsReportData: any | null;
    portCallsReportLoading: boolean;
    portCallsReportError: Error | null;
};

export type TVoyagesReportSliceState = {
    voyagesReportData: any | null;
    voyagesReportLoading: boolean;
    voyagesReportError: Error | null;
};

export type TColumnMappingsSliceState = {
    columnMappingsData: TColumnMappings[] | null;
    columnMappingsLoading: boolean;
    columnMappingsError: Error | null;
};

export type TAreaSignalStatisticsSliceState = {
    areaSignalStatisticsData: TAreaSignalStatistics | null;
    areaSignalStatisticsLoading: boolean;
    areaSignalStatisticsError: Error | null;
};


export type TGeneralSeaAreas = {
    id: number;
    name: string;
    signalPercent: number;
};

export type TGeometry = {
    type: string
    coordinates: [number[][]]; // MultiPolygon or Polygon
}

export type TReportRequestParams = {
    reportType: ReportType;
    imoList: number[];
    sectors: string[];
    startDate?: string; // DateTime as ISO string
    endDate?: string; // DateTime as ISO string
    requestedColumns?: string[];
    frequency?: string;
    minLat?: number | null;
    maxLat?: number | null;
    minLong?: number | null;
    maxLong?: number | null;
    seaArea?: string;
    polygonIds?: string[];
    durationMin?: number | null; // in days
    durationMax?: number | null; // in days
    ballastLadenStatus?: string | null; // 'ballast', 'laden', 'all'
    designDraftMin?: number | null; // in percent
    designDraftMax?: number | null; // in percent
    activities?: string[] | null; // array of activities: 'discharge', 'load', 'unclassified'
    originStartDate?: string; // DateTime as ISO string
    originEndDate?: string; // DateTime as ISO string
    originMinLat?: number | null;
    originMaxLat?: number | null;
    originMinLong?: number | null;
    originMaxLong?: number | null;
    originSeaArea?: string;
    originPolygonIds?: string[];
    destinationStartDate?: string; // DateTime as ISO string
    destinationEndDate?: string; // DateTime as ISO string
    destinationMinLat?: number | null;
    destinationMaxLat?: number | null;
    destinationMinLong?: number | null;
    destinationMaxLong?: number | null;
    destinationSeaArea?: string;
    destinationPolygonIds?: string[];
    fileType: string; // 'csv', 'xlsx', 'json', 'parquet'
};

// export type TStoppageEventsReportRequestParams = {
//     imoList: number[];
//     sectors: string[];
//     startDate: string; // DateTime as ISO string
//     endDate: string; // DateTime as ISO string
//     requestedColumns?: string[];
//     minLat?: number | null;
//     maxLat?: number | null;
//     minLong?: number | null;
//     maxLong?: number | null;
//     seaArea: string;
//     durationMin?: number | null; // in days
//     durationMax?: number | null; // in days
//     ballastLadenStatus?: string | null; // 'ballast', 'laden', 'all'
//     designDraftMin?: number | null; // in percent
//     designDraftMax?: number | null; // in percent
//     activityType?: string | null; // 'discharge', 'load', 'unclassified'
//     fileType: string; // 'csv', 'xlsx', 'json', 'parquet'
// };

// export type TPortCallsReportRequestParams = {
//     imoList: number[];
//     sectors: string[];
//     startDate: string; // DateTime as ISO string
//     endDate: string; // DateTime as ISO string
//     requestedColumns?: string[];
//     minLat?: number | null;
//     maxLat?: number | null;
//     minLong?: number | null;
//     maxLong?: number | null;
//     seaArea: string;
//     durationMin?: number | null; // in days
//     durationMax?: number | null; // in days
//     ballastLadenStatus?: string | null; // 'ballast', 'laden', 'all'
//     designDraftMin?: number | null; // in percent
//     designDraftMax?: number | null; // in percent
//     activityType?: string | null; // 'discharge', 'load', 'unclassified'
//     fileType: string; // 'csv', 'xlsx', 'json', 'parquet'
// };

// export type TVoyagesReportRequestParams = {
//     imoList: number[];
//     sectors: string[];
//     originStartDate: string; // DateTime as ISO string
//     originEndDate: string; // DateTime as ISO string
//     originMinLat?: number | null;
//     originMaxLat?: number | null;
//     originMinLong?: number | null;
//     originMaxLong?: number | null;
//     originSeaArea: string;
//     destinationStartDate: string; // DateTime as ISO string
//     destinationEndDate: string; // DateTime as ISO string
//     destinationMinLat?: number | null;
//     destinationMaxLat?: number | null;
//     destinationMinLong?: number | null;
//     destinationMaxLong?: number | null;
//     destinationSeaArea: string;
//     requestedColumns?: string[];
//     fileType: string; // 'csv', 'xlsx', 'json', 'parquet'
// };

export type TColumnMappings = {
    columnName: string;
    databricksColumnName: string;
    uiName: string;
    groupName: string;
    columnSizeCsv: number;
    order: number;
    groupOrder: number;
    reportType: string;
};

export type TAreaSignalStatistics = {
    percent: number;
};

// slice names in the ...Slice.ts files
export const GENERAL_SEA_AREAS = "generalSeaAreas";
export const COLUMN_MAPPINGS = "columnMappings";
export const AREA_SIGNAL_STATISTICS = "areaSignalStatistics";
export const ACTIVITY_REPORT = "activityReport";
export const STOPPAGE_EVENTS_REPORT = "stoppageEventsReport";
export const PORT_CALLS_REPORT = "portCallsReport";
export const VOYAGES_REPORT = "voyagesReport";

// action types
export const actions = {
    GET_GENERAL_SEA_AREAS_REQUEST: `${GENERAL_SEA_AREAS}/getGeneralSeaAreasRequestAction`,
    GET_COLUMN_MAPPINGS_REQUEST: `${COLUMN_MAPPINGS}/getColumnMappingsRequestAction`,
    GET_AREA_SIGNAL_STATISTICS_REQUEST: `${AREA_SIGNAL_STATISTICS}/getAreaSignalStatisticsRequestAction`,
    SUBMIT_ACTIVITY_REPORT_REQUEST: `${ACTIVITY_REPORT}/submitActivityReportRequestAction`,
    SUBMIT_STOPPAGE_EVENTS_REPORT_REQUEST: `${STOPPAGE_EVENTS_REPORT}/submitStoppageEventsReportRequestAction`,
    SUBMIT_PORT_CALLS_REPORT_REQUEST: `${PORT_CALLS_REPORT}/submitPortCallsReportRequestAction`,
    SUBMIT_VOYAGES_REPORT_REQUEST: `${VOYAGES_REPORT}/submitVoyagesReportRequestAction`,
};